<template>
  <div id="add-crew" class="h-full vx-card p-4">
    <div class="required aisea-text-16-400-black mt-8 ml-8 ">
      必要事項を入力してください。「<label></label>」は入力必須項目です。
    </div>
    <div class="p-8">
      <CrewBasicInfoForm
        ref="crewBasicInfoForm"
        :isEditMode="true"
        :name.sync="name"
        :nameKana.sync="nameKana"
        :availableRoles.sync="availableRoles"
        :affiliatedCompanies.sync="affiliatedCompanies"
        :joiningDate.sync="joiningDate"
        :retirementDate.sync="retirementDate"
        :employeeNumber.sync="employeeNumber"
        :unionMember.sync="unionMember"
        :emailAddress.sync="emailAddress"
        :phoneNumber.sync="phoneNumber"
        :birthDate.sync="birthDate"
        :postalCode.sync="postalCode"
        :prefecture.sync="prefecture"
        :address.sync="address"
        :memo.sync="memo"
        :roleOptions="crewRoles"
      />
    </div>
    <div class="flex gap-x-4 justify-center mb-6">
      <Button
        type="filled"
        colorType="cancel"
        label="キャンセル"
        @click="cancel"
      />
      <Button type="filled" colorType="normal" label="保存する" @click="save" />
    </div>

    <!-- 船員登録完了ダイアログ -->
    <vs-prompt
      :active.sync="showCompleteDialog"
      :color="AISEA_COLOR.BLUE"
      buttons-hidden
      title="船員登録完了"
      class="crew-complete-dialog"
      @close="goToDetail"
    >
      <div class="mb-6 aisea-text-16-400-dark-gray">
        船員登録が完了しました。
      </div>
      <div class="flex gap-x-4 justify-center mb-4">
        <Button
          type="filled"
          colorType="cancel"
          label="一覧に戻る"
          @click="goToList"
        />
        <Button
          type="filled"
          colorType="normal"
          label="登録情報を確認"
          @click="goToDetail"
        />
      </div>
      <div class="flex justify-center">
        <TextButton
          type="flat"
          colorType="normal"
          label="続けて登録"
          @click="continueRegister"
        />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import CrewBasicInfoForm from "../crew-basic-info/CrewBasicInfoForm.vue";

import {
  EnterpriseCrewsService,
  EnterpriseCrewRolesService,
} from "../service/CrewBasicInfoService.js";
import Button from "../components/Button.vue";
import TextButton from "../components/TextButton.vue";
import { ColorMixin } from "@/mixins";
export default {
  name: "AddCrew",
  components: {
    CrewBasicInfoForm,
    Button,
    TextButton,
  },
  mixins: [ColorMixin],
  data() {
    return {
      crewRoles: [],

      name: "",
      nameKana: "",
      availableRoles: [],
      affiliatedCompanies: [],
      joiningDate: "",
      retirementDate: "",
      employeeNumber: "",
      unionMember: false,
      emailAddress: "",
      phoneNumber: "",
      birthDate: "",
      postalCode: "",
      prefecture: "",
      address: "",
      memo: "",
      showCompleteDialog: false,
      createdCrewId: null,
    };
  },
  methods: {
    async fetchCrewRoles() {
      const crewRoles = await EnterpriseCrewRolesService.fetch();
      this.crewRoles = crewRoles;
    },
    cancel() {
      this.$router.push({ name: "enterprise-management-crew-settings-list" });
    },
    async save() {
      const isValid = this.$refs.crewBasicInfoForm.validate();
      if (!isValid) {
        this.$vs.notify({
          title: "エラー",
          text: "入力内容を確認してください",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return;
      }
      try {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
        const payload = {
          name: this.name,
          name_kana: this.nameKana,
          available_roles: this.availableRoles,
          affiliated_companies: this.affiliatedCompanies,
          joining_date: this.joiningDate,
          retirement_date: this.retirementDate,
          employee_number: this.employeeNumber,
          union_member: this.unionMember,
          email_address: this.emailAddress,
          phone_number: this.phoneNumber,
          birth_date: this.birthDate,
          postal_code: this.postalCode,
          prefecture: this.prefecture,
          address: this.address,
          memo: this.memo,
        };
        const crew = await EnterpriseCrewsService.add(payload);
        this.createdCrewId = crew && crew.id ? crew.id : null;
        this.showCompleteDialog = true;
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: "エラー",
          text: "船員の追加に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },
    goToList() {
      this.showCompleteDialog = false;
      this.$router.push({ name: "enterprise-management-crew-settings-list" });
    },
    goToDetail() {
      this.showCompleteDialog = false;
      if (this.createdCrewId) {
        this.$router.push({
          name: "enterprise-management-crew-settings-info",
          params: { id: this.createdCrewId },
        });
      } else {
        this.goToList();
      }
    },
    continueRegister() {
      this.showCompleteDialog = false;
      // 入力値を初期化
      this.name = "";
      this.nameKana = "";
      this.availableRoles = [];
      this.affiliatedCompanies = [];
      this.joiningDate = "";
      this.retirementDate = "";
      this.employeeNumber = "";
      this.unionMember = false;
      this.emailAddress = "";
      this.phoneNumber = "";
      this.birthDate = "";
      this.postalCode = "";
      this.prefecture = "";
      this.address = "";
      this.memo = "";

      // フォームのバリデーションエラーもクリア
      if (
        this.$refs.crewBasicInfoForm &&
        typeof this.$refs.crewBasicInfoForm.clearErrors === "function"
      ) {
        this.$refs.crewBasicInfoForm.clearErrors();
      }
    },
  },
  created() {
    this.fetchCrewRoles();
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";
.required label {
  &:after {
    content: "*";
    color: rgba(var(--vs-danger), 1);
  }
}
</style>
